import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import GlobalSetting from "../pages/Global Setting";
import AddEditUserManagement from "../pages/UserManagement/AddEditUser";
import UserManagementList from "../pages/UserManagement/List";
import ViewUserManagement from "../pages/UserManagement/ViewUser";
import { Loader } from "../components/CustomLoader";
import Chat from "../pages/ChatManagement/Chat";
import FriendList from "../pages/ChatManagement/FriendList";
import ChatScreen from "../pages/ChatManagement/ChatView";
import SupportChat from "../pages/SupportChat/SupportChat";
import AddEditColors from "../pages/ColorManagement/AddEditColors";


//CMS............................................................ ............................
const CmsPage = lazy(() => import("../pages/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/cms/AddEditCms"));

//MyAccount........................................................................................
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));

const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const LoadingFallback = <div><Loader /></div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = () => {
  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        { element: <Navigate to="/user-management" />, index: true },

        // {
        //   path: "reset-password",
        //   element: makeLazyComponent(() => <ChangePassword />),
        // },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: makeLazyComponent(() => <GlobalSetting />),
        },
        {
          path: "user-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <UserManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewUserManagement />),
            },
          ],
        },


        {
          path: "support-chat",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <SupportChat />),
            },
          ],
        },
        {
          path: "colors-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <AddEditColors />),
            },
          ],
        },

        {
          path: "cms",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CmsPage />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCms />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCms />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewCms />),
            },

          ],
        },
        //  {
        //       path: "about-us",
        //       element: makeLazyComponent(() => <AboutUs />),
        //     },
        {
          path: "chat",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <Chat />),
            },
            {
              path: "friends/:id",
              element: makeLazyComponent(() => <FriendList />),
            },

            {
              path: "view/:id",
              element: makeLazyComponent(() => <ChatScreen />),
            },
          ],
        },

      ],
    },
    { path: "*", element: <Navigate to="/user-management" /> },
  ];

  return useRoutes(routes);
};

export default MainRouting;